import { useI18n } from 'vue-i18n';
import { permissionsState } from '../services/permissionsService';
import { COUNTRY_CONFIGS } from './useCustomerInternationalConfig';

type Id = number | string;

/**
 * A moeda de UMA franquia, vinda do país dela (`PaisISO` das permissões).
 *
 * `n(valor, 'currency')` sozinho formata na moeda do IDIOMA do usuário: um Full
 * brasileiro olhando uma unidade do Chile veria R$ num valor em pesos. Combo
 * tem preço na moeda local da unidade (NS 2026-0090), então a tela formata pela
 * franquia. Sem país conhecido (franquia fora do alcance, permissões em cache
 * de antes do `PaisISO`) devolve null e a tela cai no formato do idioma.
 */
export function moedaDaFranquia(franchiseId: Id | null | undefined): string | null {
  if (franchiseId === null || franchiseId === undefined) return null;
  const iso = String(permissionsState.franquias[franchiseId]?.Dados?.PaisISO ?? '').toUpperCase();
  const pais = (COUNTRY_CONFIGS as Record<string, { currency?: string }>)[iso];
  return pais?.currency ?? null;
}

export function useMoedaFranquia() {
  const { n } = useI18n();

  /** `valor` já em unidades da moeda (reais, pesos), não em centavos. */
  function formatarMoeda(valor: number, franchiseId: Id | null | undefined): string {
    const currency = moedaDaFranquia(franchiseId);
    return currency ? n(valor, { key: 'currency', currency }) : n(valor, 'currency');
  }

  return { formatarMoeda };
}
